import type { SearchResult } from '@gat-ship/types'

/**
 * Filters navigation shortcuts by a search term, matching
 * case-insensitively on the title or any of the `searchValues` aliases.
 */
export function filterNavigationItems(
  items: readonly SearchResult[],
  search: string
): SearchResult[] {
  const needle = search.toLowerCase()
  return items.filter(
    (item) =>
      item.title.toLowerCase().includes(needle) ||
      item.searchValues?.some((value) => value.toLowerCase().includes(needle))
  )
}
